import { useQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { PATHS } from '@shared/api-contracts/paths'
import { apiFetch } from '@/api/client'

type THelloResponse = {
  message: string
}

export const HelloPage = () => {
  const { t } = useTranslation()

  const { data, isPending, isError } = useQuery({
    queryKey: [ 'hello' ],
    queryFn:  () => apiFetch<THelloResponse>(PATHS.hello),
  })

  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-2">
      <h1 className="text-2xl font-semibold">{t('hello.title')}</h1>
      <p className="text-sm text-gray-500">
        {isPending && t('hello.loading')}
        {isError && t('hello.error')}
        {data?.message}
      </p>
    </main>
  )
}
